import {useAuth} from "base/auth";

const EditorHiddenAuth = ({children}) => {
    const {ROLES, hasRole} = useAuth();

    return !hasRole(ROLES.EDITOR) && !hasRole(ROLES.CONCELLO) ? <>{children}</> : null;
};

export default EditorHiddenAuth;
